import { useAuthModal } from "@/store/useAuthModal";

/**
 * Cổng kiểm tra đăng nhập cho các hành động Pro.
 * Trả về true nếu user đã đăng nhập; nếu chưa, mở popup mời đăng nhập
 * (AuthModal) và trả về false để caller dừng hành động.
 */
export const useAuthGate = () => {
  const user = useSupabaseUser();
  const authModal = useAuthModal();

  const requireLogin = (): boolean => {
    if (user.value) return true;
    authModal.onOpen();
    return false;
  };

  return { requireLogin };
};
